import React,{ useEffect,useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from './hooks/useEntityCrud';
import axios from 'axios';

const Login = () => {

    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
    const [showPassword,setShowPassword] = useState(false);
    const {addData: doLogin} = useEntityCrud('User/LoginUser');
    const {readData: getRoles} = useEntityCrud('Role/GetAllRole');

    useEffect(() => {
        if(!localStorage.getItem('token') || localStorage.getItem('token') == null)
            document.body.classList.add('login-img');
    },[]);

    useEffect(() => {
        if(username && username.length){
            if(username.includes('۰'))
                setUsername(username.replace(/۰/g,'0'));
            if(username.includes('۱'))
                setUsername(username.replace(/۱/g,'1'));
            if(username.includes('۲'))
                setUsername(username.replace(/۲/g,'2'));
            if(username.includes('۳'))
                setUsername(username.replace(/۳/g,'3'));
            if(username.includes('۴'))
                setUsername(username.replace(/۴/g,'4'));
            if(username.includes('۵'))
                setUsername(username.replace(/۵/g,'5'));
            if(username.includes('۶'))
                setUsername(username.replace(/۶/g,'6'));
            if(username.includes('۷'))
                setUsername(username.replace(/۷/g,'7'));
            if(username.includes('۸'))
                setUsername(username.replace(/۸/g,'8'));
            if(username.includes('۹'))
                setUsername(username.replace(/۹/g,'9'));
        }
    },[username]);

    const login = (e) => {
        e.preventDefault();
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            username,
            password,
            token: '',
            mobile: '',
            lastName: '',
            firstName: '',
            nationalCode: '',
            roleTitle: '',
            businessId: []
        };
        doLogin(postedData).then(async ({data}) => {
            if(data.status){
                let userData = data.result;
                toast.success('ورود به سیستم با موفقیت انجام شد');
                const getAllRoles = await getRoles();
                const getAllBusiness = await axios.post('https://petromah.sabinarya.com/service/api/Business/GetAllBusiness',{},{
                    headers: {
                        Authorization: 'Bearer ' + data.result.token
                    }
                });
                const role = getAllRoles.data.result.find(item => item.id == userData.roleId);
                const business = (getAllBusiness?.data.result || []).find(item => item.id == userData.businessId);
                userData.roleTitle = role?.title;
                userData.businessTitle = business?.title;
                localStorage.setItem('user',JSON.stringify(userData));
                localStorage.setItem('businessId',userData.businessId);
                localStorage.setItem('token',data.result.token);
                localStorage.setItem('rl',data.result.roleId);
                window.location.href = '/';
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    return (
        !localStorage.getItem('token') || localStorage.getItem('token') == null ? <div className="">
        <div className="page">
            <div className="">
                <div className="container-login100">
                    <div className="wrap-login100 p-6">
                        <form className="login100-form validate-form" onSubmit={e => login(e)}>
                            <span className="login100-form-title pb-3"><b>ورود</b></span>
                            <div className="panel panel-primary">
                                <div className="panel-body tabs-menu-body p-0 pt-5">
                                    <div className="wrap-input100 validate-input input-group">
                                        <a className="input-group-text bg-white text-muted">
                                            <i className="zmdi zmdi-email text-muted" aria-hidden="true"></i>
                                        </a>
                                        <input className="input100 border-start-0 form-control ltr-input ms-0" type="text" placeholder="نام کاربری (کد ملی)" maxLength="10" onChange={e => setUsername(e.target.value)} />
                                    </div>
                                    <div className="wrap-input100 validate-input input-group" id="Password-toggle">
                                        <a className="input-group-text bg-white text-muted" onClick={() => setShowPassword(!showPassword)}>
                                            <i className="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
                                        </a>
                                        <input className="input100 border-start-0 form-control ltr-input ms-0" type={showPassword ? 'text' : 'password'} placeholder="رمز عبور" onChange={e => setPassword(e.target.value)} />
                                    </div>
                                    <div className="container-login100-form-btn">
                                        <button className="btn login100-form-btn btn-primary" id="btn-submit-form">ورود</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div> : <Navigate to="/" />
    );
}

export default Login;